import React from 'react';
import { Wrapper, Header, Footer, Main, View } from './index';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import './standardLayout.scss';
import { ReactComponent as Logo } from 'images/occu-logo.svg';
import HousingBadge from 'images/Housing-Badge.png';
import NCUABadge from 'images/NCUA-Badge.svg';
import SubFooter from './mortgage/subFooter';

const StandardLayout = (props) => {
  return (
    <Wrapper>
      <Header>
        <div style={{ maxWidth: 210, marginLeft: '4rem' }}>
          <Logo className="logo" />
        </div>
      </Header>
      <Main>{props.children}</Main>
      <SubFooter /> {/* TODO: Phase 2 we can make a context-based subfooter */}
      <Footer>
        <View>
          <Row className="justify-content-md-center p-4">
            <Col md="auto" className="occu-bs-border-right">
              <a
                href="https://www.orangecountyscu.org/globalassets/pdf-files/disclosures/orange-countys-credit-union-ccpa-disclosure-12-31-2019.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                CA Privacy Notice
              </a>
            </Col>
            <Col md="auto" className="occu-bs-border-right">
              <a
                href="https://www.orangecountyscu.org/globalassets/pdf-files/disclosures/disc-occu-privacy-notice-federal.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Notice
              </a>
            </Col>
            <Col md="auto" className="occu-bs-border-right">
              <a
                href="https://www.orangecountyscu.org/globalassets/pdf-files/disclosures/disc-online-privacy-policy.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Online Privacy Policy
              </a>
            </Col>
            <Col md="auto" className="occu-bs-border-right">
              NMLS # 403462
            </Col>
          </Row>
          <Row>
            <Col>
              <p>
                If you're using a screen reader or other auxiliary aid and having problems using this website, please
                call 1-888-354-6228 for assistance.
              </p>
              <p>Copyright ©{new Date().getFullYear()} Orange County's Credit Union. All Rights Reserved.</p>
              <p>
                Membership is required. Membership in Orange County's Credit Union is available to anyone who live or
                Works in Orange, Los Angeles, Riverside, or San Bernadino Counties. Don't live or work in our area? You
                may also qualify through your employer or if your immediate family Member banks with us. Ask for
                details. Membership fee is $5.{' '}
              </p>
            </Col>
          </Row>
          <Row className="justify-content-md-center">
            <Col md="auto">
              <img src={HousingBadge} alt="Housing-Badge" className="icons" />
              <p>
                Orange County's <br />
                Credit Union is <br />
                an Equal Opportunity lender
              </p>
            </Col>
            <Col md="1" />
            <Col md="auto">
              <img src={NCUABadge} alt="NCUA-Badge" className="icons" />
              <p>
                Federally Insured
                <br /> by NCUA
              </p>
            </Col>
          </Row>
        </View>
      </Footer>
    </Wrapper>
  );
};

export default StandardLayout;
